import styled from 'styled-components'

export const HotlineChamberParentContainer = styled.div`
  width: 100%;
  height: 100vh;
  font-family: Outfit;
  background: #fff;
  display: flex;
  @media print {
    .hide-on-print {
      display: none;
    }
    @page {
      size: A4;
      orientation: portrait;

      /* Enable background graphics */
      -webkit-print-color-adjust: exact; /* For Chrome */
      print-color-adjust: exact; /* For other browsers */
    }
  }
`

export const HotlineChamberVideoPart = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  @media print {
    display: none;
  }
`

export const HotlineChamberInteractionPart = styled.div`
  /* Sizing */
  width: 650px;
  min-width: 400px;
  max-width: 60%;
  
  /* Height and Scrolling - CRITICAL */
  height: 100%;
  min-height: 0; /* Allow flex item to shrink below content size */
  overflow-y: auto;
  overflow-x: hidden;
  
  /* Flex behavior in parent flex container */
  flex-shrink: 0;
  
  /* Appearance */
  padding: 0;
  background: linear-gradient(to bottom, rgba(250, 250, 255, 0.5), rgba(255, 255, 255, 0.5));
  
  /* Modern scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: rgba(103, 121, 227, 0.3) rgba(103, 121, 227, 0.05);
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(103, 121, 227, 0.05);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(103, 121, 227, 0.3);
    border-radius: 4px;
    transition: background 0.2s ease;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(103, 121, 227, 0.5);
  }
`

export const HotlineSectionSeparator = styled.div`
  width: 8px;
  height: 100%;
  background: linear-gradient(to right, rgba(103, 121, 227, 0.1), rgba(116, 80, 170, 0.1));
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: col-resize;
  position: relative;
  z-index: 10001 !important; /* Higher than Agora button container (10000) to ensure resizer is always clickable */
  transition: all 0.2s ease;
  border-left: 1px solid rgba(103, 121, 227, 0.15);
  border-right: 1px solid rgba(116, 80, 170, 0.15);
  
  &:hover {
    width: 12px;
    background: linear-gradient(to right, rgba(103, 121, 227, 0.2), rgba(116, 80, 170, 0.2));
    border-left: 2px solid rgba(103, 121, 227, 0.4);
    border-right: 2px solid rgba(116, 80, 170, 0.4);
  }
  
  &:active {
    width: 16px;
    background: linear-gradient(to right, rgba(103, 121, 227, 0.3), rgba(116, 80, 170, 0.3));
  }
  
  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 4px;
    height: 60px;
    background: linear-gradient(to bottom, 
      rgba(103, 121, 227, 0.4) 0%, 
      rgba(103, 121, 227, 0.6) 50%, 
      rgba(103, 121, 227, 0.4) 100%);
    border-radius: 2px;
    transition: all 0.2s ease;
  }
  
  &:hover::before {
    width: 6px;
    height: 80px;
    background: linear-gradient(to bottom, 
      rgba(103, 121, 227, 0.6) 0%, 
      rgba(103, 121, 227, 0.8) 50%, 
      rgba(103, 121, 227, 0.6) 100%);
  }
  
  @media print {
    display: none;
  }
`

export const HCIPMenuContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
  padding: 12px;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid rgba(103, 121, 227, 0.1);
`

export const HCIPMenuItem = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #c6c6c6;
  font-weight: 600;
  font-size: 14px;
  color: ${(props) => (props?.selected ? '#fff' : '#333')};
  background: ${(props) => (props?.selected ? '#6779e3' : '#fff')};
  ${(props) => props?.endVariant && 'background: #ff0f00;'};
  ${(props) => props?.endVariant && 'color: #fff;'};
  ${(props) => props?.endVariant && 'border: 1px solid #ff0f00;'};
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  min-height: 36px;
  white-space: nowrap;

  &:hover {
    background: ${(props) => (props?.selected ? '#5567d8' : '#f5f5f5')};
    border-color: ${(props) => (props?.selected ? '#5567d8' : '#999')};
    color: ${(props) => (props?.selected ? '#fff' : '#333')};
  }

  &:active {
    transform: scale(0.95);
  }
`
